import React, { useEffect, useState } from "react";
import { Backdrop, Box, CircularProgress } from "@mui/material";
import styles from "./addGroupComponent.module.scss";
import i18next from "i18next";
import * as Yup from "yup";
import { generalValidationMessage } from "../../../../config/appConfig";
import MultistepForm, {
  FormStep,
} from "../../../../components/mutiStepForm/MultistepForm";
import GroupFormComponent from "./GroupFormSection";
import { postGroupDetails } from "../../../../services/APIService";
import _ from "lodash";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import PropTypes from "prop-types";

const AddGroupComponent = (props) => {
  const {
    setOpenSnackbar,
    handleCancel,
    setAddGroupDrawerState,
    groupName,
    refreshTable,
    id,
    groupDetails = {},
  } = props;

  const translatedGeneralValidationMessage = `${i18next.t(
    generalValidationMessage
  )}`;
  const defaultInitialValue = {
    group_Name: groupName,
    group_email_id: "",
    group_City: "",
  };
  const initialValues = id === 0 ? defaultInitialValue : groupDetails;
  const [isLoading, setIsLoading] = useState(false);
  
  const { setApiErrorModalState } = useApiErrorModalContext();
  const validationSchema = Yup.object().shape({
    group_Name: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
    group_email_id: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .email(translatedGeneralValidationMessage),
  });

  const handleGroupSubmit = (values) => {
    _.set(values, 'group_Name', _.get(values, 'group_Name', '').trim());   
    let payload = {
      ...values,
      ...{
        isAssign: false,
        id: _.get(values, "id", 0),
        dealergroup_Id: _.get(values, "dealergroup_Id", 0),
      },
    };
    setIsLoading(true);
    postGroupDetails(payload)
      .then((response) => {
        if (!_.isEmpty(_.get(response, "errorMessage", "")) || _.get(response, "success", true) === false) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
          setIsLoading(false);
        } else {
          refreshTable();

          setAddGroupDrawerState(false);
          setOpenSnackbar(true);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setApiErrorModalState({ error: err });
      });
  };

  useEffect(() => {
    document.getElementById("addGroupMainWrapper").scrollIntoView =
      function () {};
  }, []);
  return (
    <Box
      className={styles.addGroupWrapper}
      id="addGroupMainWrapper"
      data-testid="AddGroupComponent"
    >
       <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MultistepForm
        defaultValue={initialValues}
        onSubmit={(values, props) => {
          handleGroupSubmit(values);
        }}
        onCancel={() => handleCancel("AddGroup")}
        hasHeader={false}
        formName="Group"
      >
        <FormStep
          stepName=""
          onSubmit={() => console.log("Step1 Submit")}
          validationSchema={validationSchema}
        >
          <GroupFormComponent />
        </FormStep>
      </MultistepForm>
    </Box>
  );
};

export default AddGroupComponent;
AddGroupComponent.propTypes = {
  setOpenSnackbar: PropTypes.any,
  handleCancel: PropTypes.any,
  setAddGroupDrawerState: PropTypes.any,
  groupName: PropTypes.any,
  refreshTable: PropTypes.any,
  id: PropTypes.any,
  groupDetails: PropTypes.any,
};
